'use strict';


// Add tabindex to all links
let all_links_for_index = document.querySelectorAll('a');
all_links_for_index.forEach(link => {
    link.setAttribute( 'tabindex', '0' );
});

// Update all links with role
let all_buttons_for_role = document.querySelectorAll('a');
all_buttons_for_role.forEach(button => {
    button.setAttribute( 'role', 'button' );
});

// Update all tables with role
let all_tables_for_role = document.querySelectorAll('table');
all_tables_for_role.forEach(table => {
    table.setAttribute( 'role', 'presentation' );
});


// Get each menu item button and open menu on click
let submenu_buttons = document.querySelectorAll( 'button.wp-block-navigation__submenu-icon' );

for (var i = 0; i < submenu_buttons.length; i++) {
	submenu_buttons[i].addEventListener('click', toggleDropdown);
}

function toggleDropdown() {
	this.parentElement.classList.toggle( 'submenu-open' );
}



/* 
 * Search Functionality
 */

// Search trigger functionality
let search_triggers = document.querySelectorAll( 'form.wp-block-search:not(.search-overlay-form) button.wp-block-search__button' );
let search_overlay = document.querySelector( '#search-overlay' );
let content = document.querySelector( 'html' );

for (var i = 0; i < search_triggers.length; i++) {
	// Remove default WP click functionality
	search_triggers[i].setAttribute( 'data-wp-on--click', '' );
	// Set aria-label 
	search_triggers[i].setAttribute( 'aria-label', 'Search' );
	// Add manual click event
	search_triggers[i].addEventListener( 'click', showSearchOverlay );
}

function showSearchOverlay() {
	if ( search_overlay ) {
		search_overlay.classList.add( 'active' );
		content.classList.add( 'overlay-active' );
		search_overlay.querySelector( '.wp-block-search__input' ).focus();
	}
	return false;
}

// Search close functionality
let search_close = document.querySelector( '#search-overlay-close a' );

// Add aria labels to button
if ( search_close ) {
	search_close.setAttribute( 'aria-label', 'Close Search Overlay' );
	search_close.setAttribute( 'tabindex', '0' );
}

search_close.onclick = function(){
	search_overlay.classList.remove( 'active' );
	content.classList.remove( 'overlay-active' );
	return false;
}


/*
 * Header Functionality
 */
addHeaderClass();

window.addEventListener('scroll', function() {
	addHeaderClass();
});

function addHeaderClass() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > 0) {
		document.querySelector( 'body' ).classList.add( 'menu-active' );
	} else {
		document.querySelector( 'body' ).classList.remove( 'menu-active' );
	}
}

const menu_links = document.querySelectorAll( 'ul.wp-block-navigation__container li' );

for (var i = menu_links.length - 1; i >= 0; i--) {
	if ( 1200 < document.querySelector( 'body' ).offsetWidth ) {
		menu_links[i].addEventListener( 'mouseover', function() {
			document.querySelector( 'body' ).classList.add( 'menu-hovered' );
		});
		menu_links[i].addEventListener( 'mouseout', function() {
			document.querySelector( 'body' ).classList.remove( 'menu-hovered' );
		});
	}
}

